import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import {
  BarNavigation,
  ButtonBar,
  Barragem,
  LoadingModal,
  NewOficioModal,
} from "../../components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorOutline } from "@mui/icons-material";
import { useBarragemContext, useUserContext } from "../../context";
import { generateRandomHash, useWindowSize } from "../../core";
import { SectionI, SectionII, SectionIII, SectionIV, SectionV } from "../Section";

export const BarragemPage: React.FC = () => {
  const user = useUserContext();
  const { palette } = useTheme();
  const { height } = useWindowSize();

  const navigate = useNavigate();
  const barragemData = useBarragemContext().barragem;

  const [buttons, setButtons] = useState<ButtonBar<JSX.Element | "openModal">[]>([]);
  const [openNewOficio, setOpenNewOficio] = useState(false);
  const [screenKey, setScreenKey] = useState("");

  useEffect(() => {
    if (!barragemData || "error" in barragemData) return;

    const buttons: ButtonBar<JSX.Element | "openModal">[] = [
      {
        text: barragemData.nome.toUpperCase(),
        select: true,
        args: <Barragem />,
      },
      {
        text: "SEÇÃO I",
        select: false,
        args: <SectionI />,
      },
      {
        text: "SEÇÃO II",
        select: false,
        args: <SectionII />,
      },
      {
        text: "SEÇÃO III",
        select: false,
        args: <SectionIII />,
      },
      {
        text: "SEÇÃO IV",
        select: false,
        args: <SectionIV />,
      },
      {
        text: "SEÇÃO V",
        select: false,
        args: <SectionV />,
      },
    ];

    if (user && !("error" in user) && user.admin) {
      buttons.push({
        text: "Novo Ofício",
        select: false,
        args: "openModal",
      });
    }

    setButtons([...buttons]);
  }, [barragemData, user]);

  if (!barragemData) {
    return <LoadingModal open={true} message="Aguardando dados da barragem" />;
  }

  if ('error' in barragemData) {
    return (
      <Box
        sx={{
          padding: "5em",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <ErrorOutline color="error" />
        <div style={{ width: "15px" }} />
        <Box>
          <Typography
            fontWeight={"bold"}
            color={palette.getContrastText(palette.background.paper)}
          >
            {barragemData?.error ?? "Erro na Barragem"}
          </Typography>
          <Typography
            color={palette.getContrastText(palette.background.paper)}
          >
            {barragemData?.message ?? "Erro obtendo os dados da barragem"}
          </Typography>
        </Box>
      </Box>
    );
  }

  return <>
    <NewOficioModal
      open={openNewOficio}
      onAdd={() => {
        setScreenKey(generateRandomHash(8));
        setOpenNewOficio(false);
      }}
      onCancel={() => setOpenNewOficio(false)}
    />

    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <BarNavigation<JSX.Element | "openModal" >
        onHome={() => navigate(`/app/home/${barragemData?.idEmpreendimento}`)}
        onConfig={(user && !("error" in user) && user.admin) ? () => navigate(`/app/${barragemData?.id}/config`) : undefined}
        buttons={buttons}
        onClick={(index, args) => {
          if (args === "openModal") {
            setOpenNewOficio(true);
            return;
          }

          let indexTrue = -1;
          const newButtons = buttons.map((button, i) => {
            if (button.select) indexTrue = i;
            return {
              ...button,
              select: i === index,
            };
          });

          if (indexTrue !== index) {
            setButtons(newButtons);
          }
        }}
      />

      <Box
        key={screenKey}
        sx={{
          display: "flex",
          width: "100vw",
          flexDirection: "row",
          height: `${height - 46}px`,
        }}
      >
        {barragemData && buttons.length && buttons.filter(val => val.select)[0].args}
        {!barragemData && <Skeleton sx={{ width: "100%", height: "100%" }} />}
      </Box>
    </Box>

  </>;
};
